export interface OrganizationCustomizationAvatarParams {
  OrganizationId: string;
  OrganizationCustomizationId?: string;
  OrganizationAvatar?: string;
}

export interface ApiOrganizationCustomizationAvatar {
  AccountId: string;
  OrganizationAvatarUrl: string;
  OrganizationId: string;
}

export interface OrganizationCustomizationAvatar {
  accountId: string;
  organizationAvatarUrl: string;
  organizationId: string;
}

export function apiOrganizationCustomizationAvatarToOrganizationCuztomizationAvatar(
  apiOrganizationCustomizationAvatar: ApiOrganizationCustomizationAvatar
): OrganizationCustomizationAvatar {
  return {
    accountId: apiOrganizationCustomizationAvatar.AccountId,
    organizationAvatarUrl: apiOrganizationCustomizationAvatar.OrganizationAvatarUrl,
    organizationId: apiOrganizationCustomizationAvatar.OrganizationId
  };
}
